(function () {

  /* =========================
     Random control
     ========================= */

  // 初回だけ出現率を効かせる
  function applyWeightedFirstSlide(box) {
    const wrapper = box.querySelector('.slideshow__contents-wrapper .swiper-wrapper');
    if (!wrapper) return;

    const slides = Array.from(wrapper.children);
    if (slides.length <= 1) return;

    const pool = [];
    slides.forEach((slide, i) => {
      const weight = Number(slide.dataset.weight) || 1;
      for (let w = 0; w < weight; w++) pool.push(i);
    });

    const pickedIndex = pool[Math.floor(Math.random() * pool.length)];
    wrapper.insertBefore(slides[pickedIndex], slides[0]);
  }

  // 並び順シャッフル
  function shuffleSlides(box) {
    const wrapper = box.querySelector('.slideshow__contents-wrapper .swiper-wrapper');
    if (!wrapper) return;

    const slides = Array.from(wrapper.children);
    if (slides.length <= 1) return;

    slides.sort(() => Math.random() - 0.5);
    wrapper.innerHTML = '';
    slides.forEach(slide => wrapper.appendChild(slide));
  }

  /* =========================
     Corner logo helpers
     ========================= */

  function hideAllCornerLogos(swiper) {
    swiper.slides.forEach(slide => {
      const logo = slide.querySelector('.slideshow__corner-logo');
      if (logo) logo.classList.remove('is-visible');
    });
  }

  function showActiveCornerLogo(swiper, delay = 800) {
    const slide = swiper.slides[swiper.activeIndex];
    if (!slide) return;

    const logo = slide.querySelector('.slideshow__corner-logo');
    if (!logo) return;

    clearTimeout(logo._timer);
    logo._timer = setTimeout(() => {
      logo.classList.add('is-visible');
    }, delay);
  }

  /* =========================
     Slideshow init
     ========================= */

  function initSlideshow() {
    document.querySelectorAll('.slideshow').forEach(block => {
      const box = block.closest('section');
      if (!box) return;

      const isRandom = block.dataset.random === 'true';

      // 🔥 Swiper初期化「前」に必ずやる
      if (isRandom) {
        shuffleSlides(box);
        applyWeightedFirstSlide(box);
      }

      const id = box.id;
      const autoplay = block.dataset.autoplay === 'true';
      const stopAutoplay = block.dataset.stopAutoplay === 'true';
      const delay = Number(block.dataset.delay || 3) * 1000;
      const speed = Number(block.dataset.speed || 1) * 1000;
      const effect = block.dataset.effect || 'slide';

      const swiperText = new Swiper(
        `#${id} .slideshow__tabs-wrapper`,
        {
          slidesPerView: 'auto',
          spaceBetween: 24,
          allowTouchMove: false,
          speed,
          keyboard: true,
          breakpoints: {
            990: { allowTouchMove: true },
            1600: {
              allowTouchMove: false,
              keyboard: { enabled: false }
            }
          }
        }
      );

      const swiperImg = new Swiper(
        `#${id} .slideshow__contents-wrapper`,
        {
          loop: true,
          speed,
          effect,
          keyboard: true,
          autoplay: autoplay
            ? {
                delay,
                disableOnInteraction: false,
                pauseOnMouseEnter: stopAutoplay
              }
            : false,
          pagination: {
            el: `#${id} .swiper-pagination`,
            clickable: true
          },
          thumbs: { swiper: swiperText },
          on: {
            init(swiper) {
              hideAllCornerLogos(swiper);
              showActiveCornerLogo(swiper, 900);
            },
            slideChangeTransitionStart(swiper) {
              hideAllCornerLogos(swiper);
            },
            slideChangeTransitionEnd(swiper) {
              showActiveCornerLogo(swiper, 700);
            }
          }
        }
      );

      // スライド1枚なら破棄
      if (block.querySelectorAll('.slideshow__content').length === 1) {
        swiperImg.destroy(true, true);
        swiperText.destroy(true, true);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initSlideshow);
  document.addEventListener('shopify:section:load', initSlideshow);

})();
